import { useCallback, useEffect } from 'react';

import { UseBaseTable } from 'hooks/useBaseTable';

import { UserAccessStatus } from 'api/endPoints/GetReportAccessStatus';

export type UseReportAccessTableLogic = ReturnType<typeof useReportAccessTableLogic>;

interface Props {
    table: UseBaseTable['table'];
    userList: UserAccessStatus[];
}

export const useReportAccessTableLogic = ({ table, userList }: Props) => {
    const onTableSearch = useCallback(
        (value: string) => {
            table.setColumnFilters([
                {
                    id: 'reportSettingsUserName',
                    value,
                },
            ]);
            table.setPagination((prev) => ({ ...prev, page: 1 }));
        },
        [table],
    );

    // reset page to first page when sorting
    useEffect(() => {
        table.setPagination((prev) => ({ ...prev, page: 1 }));
    }, [table.sorting]);

    // For setting Total pages of the pagination component - Using client-side pagination
    useEffect(() => {
        function setPaginationTotalPages() {
            const filteredData = table.tableRef.current?.table.getFilteredRowModel().rows || [];
            const totalPages = Math.ceil(filteredData.length / table.pagination.size);
            table.setTotalPages(totalPages);
        }
        if (userList) {
            setPaginationTotalPages();
        }
    }, [userList, table.columnFilters, table.pagination.size]);

    return {
        logic: {
            onTableSearch,
        },
    };
};
